<template>
    <div class="NavDiv d-flex mx-auto mb-2" >
        <img class="NavImg logo mx-auto" src="../assets/images/logo.png" />
    </div>
</template>

<script>
export default {
    name: 'Nav',
    data () {
        return {
            
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Nav.vue